var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCopyIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 12C5.67002 12 5.38752 11.8825 5.15252 11.6475C4.91752 11.4125 4.80002 11.13 4.80002 10.8V2.79998C4.80002 2.46998 4.91752 2.18748 5.15252 1.95248C5.38752 1.71748 5.67002 1.59998 6.00002 1.59998H12.4C12.73 1.59998 13.0125 1.71748 13.2475 1.95248C13.4825 2.18748 13.6 2.46998 13.6 2.79998V10.8C13.6 11.13 13.4825 11.4125 13.2475 11.6475C13.0125 11.8825 12.73 12 12.4 12H6.00002ZM6.00002 10.8H12.4V2.79998H6.00002V10.8ZM3.60002 14.4C3.27002 14.4 2.98752 14.2825 2.75252 14.0475C2.51752 13.8125 2.40002 13.53 2.40002 13.2V3.99998H3.60002V13.2H11.2V14.4H3.60002Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/copy_icon.de5b4a8e.svg";
export { ForwardRef as ReactComponent };